export const INTERCOM_USER_JWT_COOKIE_NAME = 'intercom_user_jwt';
